import { qs, qsa, listen } from "@fluorescent/dom";
import { on } from "@/glow/events";

const selectors = {
  wrapper: "[data-truncate-wrapper]",
  content: "[data-truncate-wrapper-content]",
  toggle: "[data-truncate-toggle]",
  accordionContent: ".accordion__content",
};

const classes = {
  disableTruncation: "truncate-wrapper--disabled",
};

export default node => {
  if (!node) return;

  const wrapperEls = qsa(selectors.wrapper, node);

  if (wrapperEls.length < 1) return;

  const events = [];

  const _toggleExpanded = (e, wrapperEl) => {
    const { contentExpanded } = wrapperEl.dataset;

    wrapperEl.dataset.contentExpanded =
      contentExpanded === "true" ? "false" : "true";
  };

  const _toggleTruncation = wrapperEl => {
    const accordionWrapper = wrapperEl.closest(selectors.accordionContent);
    const contentEl = qs(selectors.content, wrapperEl);
    let accordionWasClosed = false;

    if (accordionWrapper && accordionWrapper.style.display === "none") {
      accordionWasClosed = true;
      accordionWrapper.style.display = "block";
    }

    if (contentEl) {
      const contentFit = contentEl.scrollHeight > contentEl.clientHeight;

      wrapperEl.classList.toggle(classes.disableTruncation, !contentFit);
    }

    if (accordionWrapper && accordionWasClosed) {
      accordionWrapper.style.display = "none";
    }
  };

  const _initAccordion = wrapperEl => {
    const accordionWrapper = wrapperEl.closest(selectors.accordionContent);

    // If the accordion defaults to open, we don't need to re-run `_toggleTruncation`, but if
    // the window has been resized, we do.
    if (
      accordionWrapper &&
      accordionWrapper.dataset.defaultExpanded === "false"
    ) {
      accordionWrapper.addEventListener(
        `accordion-opened-${accordionWrapper.id}`,
        () => _toggleTruncation(wrapperEl),
        { once: true }
      );
    }
  };

  wrapperEls.forEach(wrapperEl => {
    _toggleTruncation(wrapperEl);

    const toggleEl = qs(selectors.toggle, wrapperEl);

    events.push(listen(toggleEl, "click", e => _toggleExpanded(e, wrapperEl)));
    _initAccordion(wrapperEl, false);
  });

  events.push(
    on("window:width-changed", () => {
      wrapperEls.forEach(wrapperEl => {
        _toggleTruncation(wrapperEl);
      });
    })
  );

  const unload = () => {
    events?.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
};
